/**
 * Type guard utilities for common type checking patterns
 */

/**
 * Checks if a value is defined (not null or undefined)
 * @param value The value to check
 * @returns True if the value is neither null nor undefined
 */
export const isDefined = <T>(value: T | null | undefined): value is NonNullable<T> => value !== null && value !== undefined;
